import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { DatadogCurrentUserConfig } from 'src/analytics/setCurrentUser';
import { MaybeLoanID } from 'src/common/types';
import { COOKIES_LOOKUP, SessionStatus } from 'src/services/auth/constants';
import { useZillowSession } from 'src/services/auth/session/hooks/useZillowSession';
import { client } from 'src/services/datadog/client';

export const useDatadogProviderState = (loanID: MaybeLoanID) => {
    const { session, status } = useZillowSession();
    useEffect(() => {
        const setCurrentUserOnLoad = async () => {
            if (status !== SessionStatus.LOADING && session?.user) {
                const { setCurrentUser } = await import(
                    /* webpackChunkName: "setCurrentUser" */
                    'src/analytics/setCurrentUser'
                );
                const currentUserConfig: DatadogCurrentUserConfig = {
                    id: session.user.zuid ?? Cookies.get(COOKIES_LOOKUP.SESSION_GUID) ?? 'No User ID Available',
                    name: session.user.name ?? 'No Name Available',
                    email: session.user.email ?? 'No Email Available',
                };

                if (loanID) {
                    currentUserConfig.loanID = loanID;
                }
                setCurrentUser(currentUserConfig);
            }
        };
        setCurrentUserOnLoad();

        return () => {
            client.clearIdempotencyHistory();
        };
    }, [session?.user, status, loanID]);
};
